import React from "react";
import { renderGenericPageContent } from "../../utilities/renderContent";
import { useDataLayer } from "../../hooks/dataLayer";

export default function GenericPage({ data }) {
  const { pageContent, customClass } = data.datoCmsPage;

  useDataLayer({ pageType: "other" });

  return <div>{renderGenericPageContent(pageContent, customClass)}</div>;
}
